import * as angular from 'angular';

import { Injectable, Inject } from 'ng-metadata/core';
import { PopulateService } from 'services/populate.service';

@Injectable('SearchService')
export class SearchService {
  public search: any;
  public GW = (<any>window).GW;

  /**
   * Clean search state
   * @type {Object}
   */
  private cleanSearch = {
    rows: [],
    travelers: {
      adults: 1,
      children: 0,
    },
  };

  public newSearchRow = {
    term: null,
    selected: null,
    dates: {
      startDate: null,
      endDate: null,
    },
    params: {
      citizenship: {
        search: '',
        label: this.GW.geoip.country,
        code: this.GW.geoip.iso_code,
      },
      destination: {
        search: '',
        label: '',
        code: '',
      },
      residency: {
        search: '',
        label: '', // this.GW.geoip.state_name,
        code: '', // this.GW.geoip.state,
      },
    },
  };

  constructor(
    @Inject('$sessionStorage') private $sessionStorage,
    @Inject('$filter') protected $filter,
    @Inject('$window') protected $window,
    @Inject(PopulateService) private populateService: PopulateService,
  ) {}

  getSearch(clean = false) {
    const local = this.$sessionStorage.search;

    return (clean || !local || this.reset(local)) ? this.resetSearch() : local;
  }

  addSearchRow() {
    this.search.rows.push(angular.copy(this.newSearchRow));
  }

  removeSearchRow(row) {
    const index = this.search.rows.indexOf(row);
    this.search.rows.splice(index, 1);
  }

  updateSearch(newSearch) {
    this.$sessionStorage.search = newSearch;
  }

  resetSearch() {
    delete this.$sessionStorage.search;
    this.search = angular.copy(this.cleanSearch);
    this.search.rows.push(this.getDefaultSearchRow());
    return this.search;
  }

  reset(local) {
    if (!local) {
      return false;
    }
    const citizenship = this.$filter('slugify')(local.rows[0].params.citizenship.label.replace(/[\[\]]/g, ''));
    const residency = local.rows[0].params.residency.code.toLowerCase();

    return !window.location.pathname.includes(`/${citizenship}/${residency}`);
  }

  getDefaultSearchRow() {
    const searchRow: any = angular.copy(this.newSearchRow);

    // to set the default destination from the url
    const params = this.$window.location.pathname.slice(1).split('/');
    if (params.length > 0) {
      const destination = this.$window.GW.countries
        .find(country => country.label.toLowerCase() === params[0]);
      if (destination !== undefined) {
        searchRow.params.destination = {
          label: destination.label,
          code: destination.value,
        };
      }
    }

    return searchRow;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/search.service.ts